<template>
    <div>
        <v-card v-for="(productSet, i) in productSets" :key="`order-` + i" outlined class="mb-3">
            <v-card-title>
                {{ $t('bulk_orders.product_set_no', { n: i + 1 }) }}
            </v-card-title>
            <v-divider/>
            <v-card-subtitle class="pb-0">
                {{ $t('bulk_orders.products') }}
            </v-card-subtitle>
            <v-card-text>
                <v-simple-table>
                    <template v-slot:default>
                        <thead>
                        <tr>
                            <th>{{ $t('bulk_orders.preview') }}</th>
                            <th>{{ $t('bulk_orders.name') }}</th>
                            <th>{{ $t('bulk_orders.model') }}</th>
                            <th>{{ $t('bulk_orders.quantity') }}</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(product, j) in productSet.productSet" :key="`product-` + i + `-` + j">
                            <td>
                                <v-avatar size="50" tile>
                                    <v-img :src="product.image_url" contain/>
                                </v-avatar>
                            </td>
                            <td>{{ product.name }}</td>
                            <td>{{ product.model }}</td>
                            <td>{{ product.quantity }} {{ $t('products.pieces') }}</td>
                        </tr>
                        </tbody>
                    </template>
                </v-simple-table>
            </v-card-text>
            <v-divider/>
            <v-card-subtitle class="pb-0">
                {{ $t('bulk_orders.recipients') }}
            </v-card-subtitle>
            <v-card-text>
                <v-simple-table>
                    <template v-slot:default>
                        <thead>
                        <tr>
                            <th class="text-left">{{ $t('bulk_orders.address') }}</th>
                            <th class="text-left">{{ $t('bulk_orders.email') }}</th>
                            <th class="text-left">{{ $t('bulk_orders.phone') }}</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(recipient, j) in productSet.recipients" :key="`recipient-` + i + `-` + j">
                            <td>{{ recipient.address_string }}</td>
                            <td>{{ recipient.email ? recipient.email : '-' }}</td>
                            <td>{{ recipient.phone ? recipient.phone : '-' }}</td>
                        </tr>
                        </tbody>
                    </template>
                </v-simple-table>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import BulkOrderMixin from '@/mixins/BulkOrderMixin'
import ProductSetMixin from '@/mixins/ProductSetMixin'

export default {
    name: "BulkOrderSummaryComponent",
    mixins: [BulkOrderMixin, ProductSetMixin]
}
</script>
